import React, { useState } from 'react';
import { X, Upload, CheckCircle2, ChevronRight } from 'lucide-react';
interface ModalsProps {
  getStartedOpen: boolean;
  resumeReviewOpen: boolean;
  onClose: () => void;
}
export function Modals({
  getStartedOpen,
  resumeReviewOpen,
  onClose
}: ModalsProps) {
  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  if (!getStartedOpen && !resumeReviewOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      onClose();
      setSubmitted(false);
      setStep(1);
    }, 2500);
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-107" data-mp="197c0fxg4lhco">
      <div className="absolute inset-0 bg-navy-900/40 dark:bg-navy-900/80 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-108" data-mp="14alkda4bmlr9" />

      <div className="relative bg-white dark:bg-navy-800 w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200" data-id="element-109" data-mp="1e7q7bc5zql94">
        <button onClick={onClose} className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors z-10 bg-white/50 dark:bg-navy-800/50 rounded-full" data-id="element-110" data-mp="1mt50rc5dnouq">
          <X size={20} data-id="element-111" data-mp="1vuutclazwtu3" />
        </button>

        {submitted ? <div className="p-10 text-center" data-id="element-112" data-mp="20t65j2orjgfh">
            <div className="w-16 h-16 bg-emerald-100 dark:bg-emerald-900/30 text-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-113" data-mp="25qplc714019j">
              <CheckCircle2 size={32} data-id="element-114" data-mp="2ao7unyj1gii2" />
            </div>
            <h3 className="font-heading font-bold text-2xl text-navy-900 dark:text-white mb-2" data-id="element-115" data-mp="2ffzb3g8hd7uh">
              Request Received!
            </h3>
            <p className="text-slate-500 dark:text-slate-400" data-id="element-116" data-mp="2jhkr3agba28w">
              Our team will review your details and get back to you within 24
              hours.
            </p>
          </div> : <div className="p-6 sm:p-8" data-id="element-117" data-mp="2tgjt4a6kmzmx">
            <h2 className="font-heading font-bold text-2xl text-navy-900 dark:text-white mb-2" data-id="element-118" data-mp="tdr8zs089d0i">
              {getStartedOpen ? 'Start Your Career Journey' : 'Get a Free Resume Review'}
            </h2>
            <p className="text-slate-500 dark:text-slate-400 text-sm mb-8" data-id="element-119" data-mp="134lxl30y4op4">
              {getStartedOpen ? 'Tell us a bit about yourself and what you are looking to achieve.' : 'Upload your current resume and our experts will provide actionable feedback.'}
            </p>

            <form onSubmit={handleSubmit} className="space-y-5" data-id="element-120" data-mp="182dp3vxoi8ss">
              {step === 1 && <div className="space-y-4 animate-in slide-in-from-right-4" data-id="element-121" data-mp="1m26dhklqgcxl">
                  <div className="grid grid-cols-2 gap-4" data-id="element-122" data-mp="1h4n00mwv046p">
                    <div data-id="element-123" data-mp="3nu1m1rcp01bl">
                      <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" data-id="element-124" data-mp="3nt9oiazjbtio">
                        First Name
                      </label>
                      <input required type="text" className="w-full px-4 py-2.5 rounded-lg border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-900 text-slate-900 dark:text-white focus:ring-2 focus:ring-brand/50 focus:border-brand outline-none transition-all" data-id="element-125" data-mp="1ycxlhv8si04g" />
                    </div>
                    <div data-id="element-126" data-mp="1fmfx22uzpqow">
                      <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" data-id="element-127" data-mp="1fm6ircjb57z1">
                        Last Name
                      </label>
                      <input required type="text" className="w-full px-4 py-2.5 rounded-lg border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-900 text-slate-900 dark:text-white focus:ring-2 focus:ring-brand/50 focus:border-brand outline-none transition-all" data-id="element-128" data-mp="15o9z1wcb14pb" />
                    </div>
                  </div>
                  <div data-id="element-129" data-mp="14zmu9p2f4zt7">
                    <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" data-id="element-130" data-mp="14xtn88nw8dko">
                      Email Address
                    </label>
                    <input required type="email" className="w-full px-4 py-2.5 rounded-lg border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-900 text-slate-900 dark:text-white focus:ring-2 focus:ring-brand/50 focus:border-brand outline-none transition-all" data-id="element-131" data-mp="vxx40mk9w6x0" />
                  </div>

                  {getStartedOpen && <div data-id="element-132" data-mp="d8qikrs3h17i">
                      <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" data-id="element-133" data-mp="d872lgm08mw4">
                        What services are you interested in?
                      </label>
                      <select className="w-full px-4 py-2.5 rounded-lg border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-900 text-slate-900 dark:text-white focus:ring-2 focus:ring-brand/50 focus:border-brand outline-none transition-all" data-id="element-134" data-mp="3bvl8c7k56ut">
                        <option data-id="element-135" data-mp="3pafe2jwx18fl">Resume Writing</option>
                        <option data-id="element-136" data-mp="3pd1kuhbzfjwr">LinkedIn Optimization</option>
                        <option data-id="element-137" data-mp="3ubmluiz267m9">Cover Letter</option>
                        <option data-id="element-138" data-mp="33qkshoysvpo">Career Coaching</option>
                        <option data-id="element-139" data-mp="33i92t4kvwg2">Full Package</option>
                      </select>
                    </div>}

                  <button type="button" onClick={() => setStep(2)} className="w-full bg-navy-900 dark:bg-brand hover:bg-navy-800 dark:hover:bg-brand-600 text-white py-3 rounded-xl font-medium transition-colors flex items-center justify-center gap-2 mt-2" data-id="element-140" data-mp="31jt6suuqjs6n">
                    Continue <ChevronRight size={18} data-id="element-141" data-mp="2iu3dkc6mfegu" />
                  </button>
                </div>}

              {step === 2 && <div className="space-y-5 animate-in slide-in-from-right-4" data-id="element-142" data-mp="2ns4t4n4u8vnk">
                  <div data-id="element-143" data-mp="2fryx4c0rjoe5">
                    <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" data-id="element-144" data-mp="2fr6ystfs7ck6">
                      Current Job Title
                    </label>
                    <input required type="text" className="w-full px-4 py-2.5 rounded-lg border border-slate-200 dark:border-navy-600 bg-white dark:bg-navy-900 text-slate-900 dark:text-white focus:ring-2 focus:ring-brand/50 focus:border-brand outline-none transition-all" data-id="element-145" data-mp="2pitkjjpqwu16" />
                  </div>

                  <div data-id="element-146" data-mp="26tmwria3hc8i">
                    <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" data-id="element-147" data-mp="26u6byr8d1miu">
                      Upload Current Resume (Optional)
                    </label>
                    <div className="border-2 border-dashed border-slate-200 dark:border-navy-600 rounded-xl p-8 text-center hover:bg-slate-50 dark:hover:bg-navy-900/50 transition-colors cursor-pointer group" data-id="element-148" data-mp="3i677cozqc97k">
                      <div className="w-12 h-12 bg-brand-50 dark:bg-navy-800 text-brand rounded-full flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform" data-id="element-149" data-mp="3kujb7la60goh">
                        <Upload size={24} data-id="element-150" data-mp="3btl2ipos7kzk" />
                      </div>
                      <p className="text-sm font-medium text-navy-900 dark:text-white mb-1" data-id="element-151" data-mp="3fuer7la1t3ti">
                        Click to upload or drag and drop
                      </p>
                      <p className="text-xs text-slate-500 dark:text-slate-400" data-id="element-152" data-mp="cd6bb6yvse1f">
                        PDF, DOCX up to 10MB
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-3 mt-4" data-id="element-153" data-mp="2mbnhy5zl6dv">
                    <button type="button" onClick={() => setStep(1)} className="px-6 py-3 rounded-xl font-medium border border-slate-200 dark:border-navy-600 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-navy-700 transition-colors" data-id="element-154" data-mp="2kquwe38fxin">
                      Back
                    </button>
                    <button type="submit" className="flex-1 bg-brand hover:bg-brand-600 text-white py-3 rounded-xl font-medium transition-colors shadow-sm hover:shadow-md" data-id="element-155" data-mp="1kgsyncmd9o9">
                      Submit Request
                    </button>
                  </div>
                </div>}
            </form>
          </div>}
      </div>
    </div>;
}